import { createFileRoute } from "@tanstack/react-router";
import { TestPage } from "@/routes/_main/exams/$slug/test/$id/index";

export const Route = createFileRoute("/_main/groups/$gid/exams/$slug/test/$id/")({
  component: TestPage,
});
